/*
 * @Author: ningbo.kang
 * @Date: 2020-03-09 10:55:26
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-04-07 11:12:34
 * @Description: 描述
 */

// axios 不需要携带token的 接口地址
const whiteTokenList = ['/login', '/codeCallback', '/refreshToken', 'api/dashboard/cross-data'];
// axios 不需要 弹出消息 接口地址
const whiteMessageList = ['/login', '/logout', '/login?auto', '/codeCallback', '/refreshToken', '/sys/user/getUser', '/sys/menu/userMenus'];
// 在免登录白名单，直接进入
const whiteRouterList = ['/lang', '/codeCallBack', '/login', '/logout', '/MsgBoard/projectMsgBoard', '/code2token'];

export function ignoreToken(reqUrl) {
  return !whiteTokenList.includes(reqUrl);
}

/**
 * 忽略以下地址检查
 * @param {*} reqUrl
 */
export function ignoreMessage(reqUrl) {
  let flag = false;
  whiteMessageList.forEach((url) => {
    if (reqUrl.endsWith(url)) {
      flag = true;
    }
  });
  return flag;
}

export function ignoreRouter(reqUrl) {
  return whiteRouterList.includes(reqUrl);
}

export default {
  ignoreMessage,
};
